import React, { useEffect, useRef, useState } from 'react';
import { Modal, Select, Typography } from 'antd';
import { useQueryClient } from '@tanstack/react-query';
import { Button, Input, Table } from 'antd';
import { Controller, useForm } from 'react-hook-form';
import usePaginationHook from '../../../../../utils/usePagination';
import { FaDownload, FaEye, FaEyeSlash, FaUpload } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { AlertConfirm, AlertSuccess } from '../../../../util/Alert';
import fitSurvey2Services from '../../../../../services/fit-survey2.services';
import dayjs from 'dayjs';
import numeral from 'numeral';

const pageSize = 50;

const LegacySurveyPartnerListModal = ({ open, handleClose, survey }) => {
  const queryClient = useQueryClient();
  const {
    data: legacySurvey2PartnerLists,
    setData,
    page,
    setPage,
    total,
    setTotal,
  } = usePaginationHook();

  const { control, watch } = useForm({
    defaultValues: {
      searchText: '',
      answered: 'All',
      memberType: '',
    },
  });

  const {
    control: control2,
    watch: watch2,
    setValue: setValue2,
  } = useForm({
    defaultValues: {
      selectedEventId: '',
      ticketStatus: 'all',
    },
  });

  fitSurvey2Services.useQueryGetLegacySurvey2PartnerLists(
    {
      take: pageSize,
      page,
      surveyId: survey.id,
      searchText: watch('searchText'),
      isPartner: undefined,
      memberType: watch('memberType'),
      answered: watch('answered'),
    },
    (data) => {
      setData(data.data);
      setTotal(data.meta.total);
    },
  );

  const { mutate: uploadLegacySurvey2PartnerListsExcel } =
    fitSurvey2Services.useMutationUploadLegacySurvey2PartnerListsExcel(
      (data) => {
        setTimeout(() => {
          inputRef.current.value = null;

          queryClient.invalidateQueries({
            queryKey: ['get-legacy-survey2-partner-list'],
            refetchType: 'all',
          });

          setLoading(false);
        }, 600);
      },
    );

  const { mutate: uploadLegacySurvey2PartnerListsByEvent } =
    fitSurvey2Services.useMutationUploadLegacySurvey2PartnerListsByEvent(
      (data) => {
        setTimeout(() => {
          AlertSuccess(`อัพเดทรายชื่อจากงานอีเวนต์ \n ${total} รายการสำเร็จ`);

          setValue2('selectedEventId', '');

          queryClient.invalidateQueries({
            queryKey: ['get-legacy-survey2-partner-list'],
            refetchType: 'all',
          });

          setLoading2(false);
        }, 600);
      },
    );

  const _HandleUploadLegacySurvey2PartnerListsExcel = (data) => {
    setLoading(true);
    uploadLegacySurvey2PartnerListsExcel({
      data,
      surveyId: survey.id,
    });
  };

  const { mutate: deleteLegacySurvey2 } =
    fitSurvey2Services.useMutationDeleteLegacySurvey2PartnerList(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-survey2-partner-list'],
        refetchType: 'all',
      });
    });

  const { mutate: updateLegacySurvey2 } =
    fitSurvey2Services.useMutationUpdateLegacySurvey2PartnerList(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-survey2-partner-list'],
        refetchType: 'all',
      });
    });

  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [eventLists, setEventLists] = useState([]);
  const [totalMember, setTotalMember] = useState(0);
  const [totalAnswered, setTotalAnswered] = useState(0);

  const { data: data2 } =
    fitSurvey2Services.useQueryGetLegacySurvey2PartnerLists(
      {
        take: -1,
        page,
        surveyId: survey.id,
        searchText: watch('searchText'),
        isPartner: undefined,
        memberType: watch('memberType'),
        answered: 'Answered',
      },
      (data) => {
        if (watch('answered') === 'Not_Answered') {
          setTotalAnswered(0);
        } else {
          setTotalAnswered(data.meta.total);
        }
      },
    );

  useEffect(() => {
    if (data2 && data2.meta && data2.meta.total) {
      if (watch('answered') === 'Not_Answered') {
        setTotalAnswered(0);
      } else {
        setTotalAnswered(data2.meta.total);
      }
    }
  }, [watch('answered'), data2]);

  const { mutate: downloadLegacySurvey2PartnerListsExcel } =
    fitSurvey2Services.useMutationDownloadLegacySurvey2PartnerListsExcel(() => {
      setTimeout(() => {
        setLoading2(false);
      }, 600);
    });

  const { mutate: downloadLegacySurvey2PartnerListImportFormExcel } =
    fitSurvey2Services.useMutationDownloadLegacySurvey2PartnerListImportFormExcel(
      () => {
        setTimeout(() => {
          setLoading3(false);
        }, 600);
      },
    );

  fitSurvey2Services.useQueryGetEventLists(
    {
      regStatus: 'open',
    },
    (data) => {
      setEventLists(data);
    },
  );

  const { data: memberLists } = fitSurvey2Services.useQueryGetEventMemberLists({
    id: watch2('selectedEventId'),
    limit: 1,
    page: 1,
    ticketStatus: watch2('ticketStatus'),
  });

  useEffect(() => {
    if (memberLists && memberLists.pagination) {
      setTotalMember(memberLists.pagination.total);
    } else {
      setTotalMember(0);
    }
  }, [memberLists]);

  const columns =
    survey.memberType === 'Event'
      ? [
          {
            title: 'NO',
            dataIndex: 'index',
            key: 'index',
            render: (_, __, index) => (
              <span>{(page - 1) * pageSize + index + 1}</span>
            ),
          },
          {
            title: 'รหัสบัตรงาน',
            dataIndex: 'cardNo',
            key: 'cardNo',
            render: (_, record) => <span>{record.cardNo}</span>,
            width: 150,
          },
          {
            title: 'รหัสนักธุรกิจ',
            dataIndex: 'memberCode',
            key: 'memberCode',
            render: (_, record) => <span>{record.memberCode}</span>,
            width: 150,
          },
          {
            title: 'ชื่อ',
            dataIndex: 'title',
            key: 'title',
            render: (_, record) => (
              <span>
                {record?.user?.FirstNameTh && record?.user?.SurNameTh
                  ? `${record?.user?.FirstNameTh} ${record?.user?.SurNameTh}`
                  : `${record?.firstName} ${record?.lastName}`}
              </span>
            ),
            width: 150,
          },
          {
            title: 'รหัสหลัก / รหัสร่วม',
            dataIndex: 'isPartner',
            key: 'isPartner',
            render: (_, record) => (
              <span>
                {record.isPartner
                  ? 'รหัสร่วม'
                  : record.memberCode
                    ? 'รหัสหลัก'
                    : 'คนใหม่'}
              </span>
            ),
            width: 150,
          },
          {
            title: 'เบอร์โทรศัพท์',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            render: (_, record) => <span>{record.phoneNumber}</span>,
            width: 200,
          },
          {
            title: 'ตำแหน่ง',
            dataIndex: 'HonorCode',
            key: 'HonorCode',
            render: (_, record) => <span>{record.HonorCode}</span>,
            width: 150,
          },
          {
            title: 'องค์กร',
            dataIndex: 'TeamName',
            key: 'TeamName',
            render: (_, record) => <span>{record.TeamName}</span>,
            width: 150,
          },
          {
            title: 'สถานะการตอบ',
            dataIndex: 'answered',
            key: 'answered',
            render: (_, record) => (
              <span>{record?.userSurvey ? 'ตอบแล้ว' : 'ยังไม่ตอบ'}</span>
            ),
          },
          {
            title: 'ตอบเมื่อ',
            dataIndex: 'answeredWhen',
            key: 'answeredWhen',
            render: (_, record) => (
              <span>
                {record?.userSurvey?.createdAt
                  ? dayjs(record?.userSurvey.createdAt).format(
                      'DD MMM YY เวลา HH:mm น.',
                    )
                  : '-'}
              </span>
            ),
          },
          {
            title: 'สถานะการแสดง',
            dataIndex: 'display',
            key: 'display',
            render: (_, record) => (
              <span>{record?.display ? 'แสดง' : 'ไม่แสดง'}</span>
            ),
          },
          {
            title: '',
            key: 'action',
            render: (_, record) => (
              <div
                style={{ display: 'flex', justifyContent: 'center' }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                {record.display ? (
                  <div
                    style={{ cursor: 'pointer', marginLeft: 10 }}
                    onClick={async () => {
                      const confirm = await AlertConfirm('ปิดการแสดง Survey');
                      if (confirm)
                        updateLegacySurvey2({ id: record.id, display: false });
                    }}
                  >
                    <FaEye />
                  </div>
                ) : (
                  <div
                    style={{ cursor: 'pointer', marginLeft: 10 }}
                    onClick={async () => {
                      const confirm = await AlertConfirm('เปิดการแสดง Survey');
                      if (confirm)
                        updateLegacySurvey2({ id: record.id, display: true });
                    }}
                  >
                    <FaEyeSlash />
                  </div>
                )}
                {/* <div
                  style={{ cursor: 'pointer', marginLeft: 10 }}
                  onClick={async () => {
                    const confirm = await AlertConfirm('ลบข้อมูล');
                    if (confirm) deleteLegacySurvey2({ id: record.id });
                  }}
                >
                  <MdDelete />
                </div> */}
              </div>
            ),
          },
        ]
      : [
          {
            title: 'NO',
            dataIndex: 'index',
            key: 'index',
            render: (_, __, index) => (
              <span>{(page - 1) * pageSize + index + 1}</span>
            ),
          },
          {
            title: 'รหัสนักธุรกิจ',
            dataIndex: 'memberCode',
            key: 'memberCode',
            render: (_, record) => <span>{record.memberCode}</span>,
            width: 150,
          },
          {
            title: 'ชื่อ',
            dataIndex: 'title',
            key: 'title',
            render: (_, record) => (
              <span>
                {record?.user?.FirstNameTh && record?.user?.SurNameTh
                  ? `${record?.user?.FirstNameTh} ${record?.user?.SurNameTh}`
                  : `${record?.firstName} ${record?.lastName}`}
              </span>
            ),
            width: 150,
          },
          {
            title: 'รหัสหลัก / รหัสร่วม',
            dataIndex: 'isPartner',
            key: 'isPartner',
            render: (_, record) => (
              <span>
                {record.isPartner
                  ? 'รหัสร่วม'
                  : record.memberCode
                    ? 'รหัสหลัก'
                    : 'คนใหม่'}
              </span>
            ),
            width: 150,
          },
          {
            title: 'เบอร์โทรศัพท์',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            render: (_, record) => (
              <span>
                {record.phoneNumber || record?.user?.PhoneNumber || '-'}
              </span>
            ),
            width: 150,
          },
          {
            title: 'ตำแหน่ง',
            dataIndex: 'HonorCode',
            key: 'HonorCode',
            render: (_, record) => (
              <span>{record.HonorCode || record?.user?.HonorCode || '-'}</span>
            ),
            width: 150,
          },
          {
            title: 'องค์กร',
            dataIndex: 'TeamName',
            key: 'TeamName',
            render: (_, record) => (
              <span>{record.TeamName || record?.user?.TeamName || '-'}</span>
            ),
            width: 150,
          },
          {
            title: 'สถานะการตอบ',
            dataIndex: 'answered',
            key: 'answered',
            render: (_, record) => (
              <span>{record?.userSurvey ? 'ตอบแล้ว' : 'ยังไม่ตอบ'}</span>
            ),
          },
          {
            title: 'ตอบเมื่อ',
            dataIndex: 'answered',
            key: 'answered',
            render: (_, record) => (
              <span>
                {record?.userSurvey?.createdAt
                  ? dayjs(record?.userSurvey.createdAt).format(
                      'DD MMM YY เวลา HH:mm น.',
                    )
                  : '-'}
              </span>
            ),
          },
          {
            title: 'สถานะการแสดง',
            dataIndex: 'display',
            key: 'display',
            render: (_, record) => (
              <span>{record?.display ? 'แสดง' : 'ไม่แสดง'}</span>
            ),
          },
          {
            title: '',
            key: 'action',
            render: (_, record) => (
              <div
                style={{ display: 'flex', justifyContent: 'center' }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                {record.display ? (
                  <div
                    style={{ cursor: 'pointer', marginLeft: 10 }}
                    onClick={async () => {
                      const confirm = await AlertConfirm('ปิดการแสดง Survey');
                      if (confirm)
                        updateLegacySurvey2({ id: record.id, display: false });
                    }}
                  >
                    <FaEye />
                  </div>
                ) : (
                  <div
                    style={{ cursor: 'pointer', marginLeft: 10 }}
                    onClick={async () => {
                      const confirm = await AlertConfirm('เปิดการแสดง Survey');
                      if (confirm)
                        updateLegacySurvey2({ id: record.id, display: true });
                    }}
                  >
                    <FaEyeSlash />
                  </div>
                )}
                <div
                  style={{ cursor: 'pointer', marginLeft: 10 }}
                  onClick={async () => {
                    const confirm = await AlertConfirm('ลบข้อมูล');
                    if (confirm) deleteLegacySurvey2({ id: record.id });
                  }}
                >
                  <MdDelete />
                </div>
              </div>
            ),
          },
        ];

  return (
    <Modal
      title={'รายชื่อ'}
      visible={open}
      cancelText="ปิด"
      onCancel={handleClose}
      width={'80vw'}
      okButtonProps={{ style: { display: 'none' } }}
      zIndex={1010}
    >
      <div
        style={{ display: 'flex', alignItems: 'center' }}
        className="mb-2 mt-2"
      >
        {survey.memberType === 'group' && (
          <>
            <div style={{ flex: 1 }} />
            <input
              type="file"
              id={'patient'}
              onChange={(e) => {
                if (e.target.files?.length > 0) {
                  const formData = new FormData();
                  formData.append('file', e.target.files[0]);
                  _HandleUploadLegacySurvey2PartnerListsExcel(formData);
                }
              }}
              style={{ display: 'none' }}
              ref={inputRef}
            />
            <Button
              className="mr-2"
              onClick={() => {
                if (inputRef.current) {
                  inputRef.current.click();
                }
              }}
              loading={loading}
              type="primary"
            >
              <FaUpload className="mr-2" />
              อัพโหลด excel
            </Button>
            <Button
              className="mr-2"
              ghost
              onClick={() => {
                setLoading3(true);
                downloadLegacySurvey2PartnerListImportFormExcel();
              }}
              loading={loading3}
              type="primary"
            >
              <FaDownload className="mr-2" />
              ดาวน์โหลดฟอร์ม excel
            </Button>
          </>
        )}
        {survey.memberType === 'Event' && (
          <>
            <span>งานอีเวนต์ : </span>
            <Controller
              name="selectedEventId"
              control={control2}
              render={({ field: { onChange, value } }) => {
                return (
                  <Select
                    value={value}
                    style={{ flex: 1 }}
                    onChange={onChange}
                    className="mr-2 ml-2"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  >
                    {eventLists.map((item) => {
                      return (
                        <Select.Option key={item.Id} value={item.Id}>
                          {item.EventName}
                        </Select.Option>
                      );
                    })}
                  </Select>
                );
              }}
            />
            <Controller
              name="ticketStatus"
              control={control2}
              render={({ field: { onChange, value } }) => {
                return (
                  <Select
                    value={value}
                    style={{ width: 200 }}
                    onChange={onChange}
                    placeholder="ลงทะเบียน"
                    className="mr-2"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  >
                    {[
                      { label: 'ทั้งหมด', value: 'all' },
                      { label: 'เฉพาะคนที่เข้าร่วมงาน', value: 'attended' },
                    ].map((item) => {
                      return (
                        <Select.Option key={item.value} value={item.value}>
                          {item.label}
                        </Select.Option>
                      );
                    })}
                  </Select>
                );
              }}
            />
            <Button
              className="mr-2"
              onClick={() => {
                setLoading2(true);
                uploadLegacySurvey2PartnerListsByEvent({
                  eventId: watch2('selectedEventId'),
                  surveyId: survey.id,
                  ticketStatus: watch2('ticketStatus'),
                });
              }}
              loading={loading2}
              type="primary"
              disabled={!watch2('selectedEventId') || totalMember === 0}
            >
              <FaUpload className="mr-2" />
              อัพเดทรายชื่อจากงานอีเวนต์ ({totalMember})
            </Button>
          </>
        )}
        <Button
          ghost
          onClick={() => {
            setLoading2(true);
            downloadLegacySurvey2PartnerListsExcel({
              take: -1,
              page: 1,
              surveyId: survey.id,
              searchText: watch('searchText'),
              isPartner: undefined,
              memberType: watch('memberType'),
              answered: watch('answered'),
            });
          }}
          loading={loading2}
          type="primary"
        >
          <FaDownload className="mr-2" />
          โหลด excel
        </Button>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }} className="mb-2">
        <Controller
          name="searchText"
          control={control}
          render={({ field: { onChange, value } }) => {
            return (
              <Input
                value={value}
                onChange={onChange}
                placeholder={
                  survey.memberType === 'Event'
                    ? 'ค้นหาด้วยชื่อสกุล/รหัสนักธุรกิจ/เบอร์โทรศัพท์/รหัสบัตรงาน'
                    : 'ค้นหาด้วยชื่อสกุล/รหัสนักธุรกิจ'
                }
                className="mr-2"
              />
            );
          }}
        />
        <Controller
          name="answered"
          control={control}
          render={({ field: { onChange, value } }) => {
            return (
              <Select
                value={value}
                style={{ width: 350 }}
                onChange={onChange}
                placeholder="ลงทะเบียน"
                className="mr-2"
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              >
                {[
                  { label: 'ทั้งหมด', value: 'All' },
                  { label: 'ตอบแล้ว', value: 'Answered' },
                  { label: 'ยังไม่ตอบ', value: 'Not_Answered' },
                ].map((item) => {
                  return (
                    <Select.Option key={item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  );
                })}
              </Select>
            );
          }}
        />
        <Controller
          name="memberType"
          control={control}
          render={({ field: { onChange, value } }) => {
            return (
              <Select
                value={value}
                style={{ width: 350 }}
                onChange={onChange}
                placeholder="ลงทะเบียน"
                className="mr-2"
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              >
                {[
                  { label: 'ทั้งหมด', value: '' },
                  { label: 'คนใหม่', value: 'NewMember' },
                  { label: 'นักธุรกิจ', value: 'Distributor' },
                  { label: 'VIP Member', value: 'Member' },
                ].map((item) => {
                  return (
                    <Select.Option key={item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  );
                })}
              </Select>
            );
          }}
        />
        <div
          style={{
            backgroundColor: '#cfe2f3',
            borderRadius: 5,
            padding: 10,
            marginRight: 8,
            border: '1px solid #6fa8dc',
            width: 250,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Typography.Text>เข้างาน: {total}</Typography.Text>
        </div>
        <div
          style={{
            backgroundColor: '#d9ead3',
            borderRadius: 5,
            padding: 10,
            marginRight: 8,
            border: '1px solid #93c47d',
            width: 250,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Typography.Text>
            ตอบแล้ว: {numeral(totalAnswered).format('0')}
          </Typography.Text>
        </div>
        <div
          style={{
            backgroundColor: '#fff1f0',
            borderRadius: 5,
            padding: 10,
            border: '1px solid #ffa39e',
            width: 250,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Typography.Text>
            ยังไม่ตอบ: {numeral(total - totalAnswered).format('0')}
          </Typography.Text>
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={legacySurvey2PartnerLists}
        style={{ backgroundColor: '#fff' }}
        rowKey="id"
        onChange={({ current }) => {
          setPage(current);
        }}
        pagination={{
          pageSize,
          total,
        }}
        scroll={{ x: 'max-content' }}
      />
    </Modal>
  );
};

export default LegacySurveyPartnerListModal;
